import { IFeed } from '@/models/feeds.model';

export const getCategoriesRow = (feed: IFeed) => {
  const mappedCategories = feed.categories?.map((category) => category.name)?.slice(0, 3);
  const result = feed.categories?.length > 3 ? `${mappedCategories?.join(', ')}...` : mappedCategories?.join(', ');
  return result;
};

export const getRegionsRow = (feed: IFeed) => {
  const mappedCategories = feed.regions?.map((category) => category.name)?.slice(0, 3);
  const result = feed.categories?.length > 3 ? `${mappedCategories?.join(', ')}...` : mappedCategories?.join(', ');
  return result;
};
